import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import FounderPage from '../pages/founder/page';
import EnrollPage from '../pages/enroll/page';
import OnSiteProgramsPage from '../pages/on-site-programs/page';
import OffSiteServicesPage from '../pages/off-site-services/page';
import RecordingStudioPage from '../pages/recording-studio/page';
import ContactPage from '../pages/contact/page';
import ClientPortalPage from '../pages/client-portal/page';
import NeurodivergentDevelopmentPage from '../pages/neurodivergent-development/page';
import InHomeProgramsPage from '../pages/in-home-programs/page';
import PricingSupportPage from '../pages/pricing-support/page';
import ServicesPage from '../pages/services/page';
import FAQPage from '../pages/faq/page';
import ProgramFinderPage from '../pages/program-finder/page';
import PrivacyPolicyPage from '../pages/privacy-policy/page';
import GiftCardsPage from '../pages/gift-cards/page';
import WalkInPage from '../pages/walk-in/page';
import MinistryConnectionsPage from '../pages/ministry-connections/page';
import CitiesWeServePage from '../pages/cities-we-serve/page';
import BlogPage from '../pages/blog/page';
import ReferAFriendPage from '../pages/refer-a-friend/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/meet-the-founder', element: <FounderPage /> },
  { path: '/meet-the-ceo', element: <FounderPage /> },
  { path: '/on-site-programs', element: <OnSiteProgramsPage /> },
  { path: '/off-site-services', element: <OffSiteServicesPage /> },
  { path: '/recording-studio', element: <RecordingStudioPage /> },
  { path: '/neurodivergent-development', element: <NeurodivergentDevelopmentPage /> },
  { path: '/in-home-programs', element: <InHomeProgramsPage /> },
  { path: '/pricing-support', element: <PricingSupportPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/program-finder', element: <ProgramFinderPage /> },
  { path: '/enroll', element: <EnrollPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/client-portal', element: <ClientPortalPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/gift-cards', element: <GiftCardsPage /> },
  { path: '/walk-in', element: <WalkInPage /> },
  { path: '/ministry-connections', element: <MinistryConnectionsPage /> },
  { path: '/cities-we-serve', element: <CitiesWeServePage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/refer-a-friend', element: <ReferAFriendPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
